<template>
  <div
    class="task-list-toolbar d-flex align-center"
    data-testid="setup-tasklist__toolbar"
  >
    <v-btn
      v-if="hasActiveTableFilter"
      text
      class="task-list-toolbar__clear-filter text-none"
      :disabled="disabled"
      data-testid="setup-tasklist__clear-filter-btn"
      @click="$emit('clear-filter')"
    >
      Clear Filter
    </v-btn>

    <CustomizeColumnMenu
      v-model="customizeMenuOpen"
      :headers="headers"
      :exclude-columns="['action', 'select']"
      color="caccounting"
      :show-save-button="false"
      :show-apply-button="true"
      data-testid-prefix="setup-tasklist"
      @apply="$emit('apply-columns', $event)"
    />

    <v-tooltip bottom content-class="tooltip-bottom">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          icon
          :disabled="disabled"
          aria-label="Activity Log"
          data-testid="setup-tasklist__activity-log-btn"
          @click="openActivityLog"
        >
          <img
            class="task-list-toolbar__export-icon"
            src="/img/icons/activity-log.svg"
            alt="Activity Log"
            data-testid="setup-tasklist__activity-log-btn-icon"
          />
        </v-btn>
      </template>
      <span>Activity Log</span>
    </v-tooltip>

    <ActivityLog
      v-if="activityLogOpen && activityLogResourceId"
      ref="activityLog"
      hide-trigger
      :resource-id="activityLogResourceId"
      row-description="Task Library"
      :type="activityLogTypes"
      data-testid="setup-tasklist__activity-log"
      @closed="activityLogOpen = false"
    />

    <v-tooltip bottom content-class="tooltip-bottom">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          icon
          :disabled="disabled"
          aria-label="Export"
          data-testid="setup-tasklist__export-btn"
          @click="$emit('export')"
        >
          <img class="task-list-toolbar__export-icon" src="/img/icons/fbc-icons/DownloadIcon.svg" alt="Export" />
        </v-btn>
      </template>
      <span>Export</span>
    </v-tooltip>

    <v-btn
      outlined
      class="task-list-toolbar__import-btn text-none secondaryBtn"
      :disabled="disabled"
      data-testid="setup-tasklist__bulk-import-btn"
      @click="$emit('bulk-import')"
    >
      <v-icon left small>mdi-file-document-plus-outline</v-icon>
      Bulk Import
    </v-btn>

    <v-menu
      offset-y
      left
      :nudge-bottom="6"
      content-class="task-list-toolbar__add-menu"
      transition="fade-transition"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          color="primary"
          class="task-list-toolbar__add-btn text-none white--text"
          :disabled="disabled"
          data-testid="setup-tasklist__add-template-btn"
        >
          <v-icon left small>mdi-plus</v-icon>
          Add Template
          <v-icon right small>mdi-chevron-down</v-icon>
        </v-btn>
      </template>
      <div class="task-list-toolbar__add-menu-panel" data-testid="setup-tasklist__add-template-menu">
        <p class="task-list-toolbar__add-menu-label ma-0" data-testid="setup-tasklist__add-template-menu-label">
          Select type
        </p>
        <button
          type="button"
          class="task-list-toolbar__add-menu-item"
          data-testid="setup-tasklist__add-ar-btn"
          @click="$emit('add-template', arType)"
        >
          Account Reconciliation
        </button>
        <button
          type="button"
          class="task-list-toolbar__add-menu-item"
          data-testid="setup-tasklist__add-checklist-btn"
          @click="$emit('add-template', checklistType)"
        >
          Checklist
        </button>
      </div>
    </v-menu>
  </div>
</template>

<script>
import './TaskListToolbar.scss';
import { ACTIVITY_LOG_TYPES } from '../../../../../utils/constants';
import { CustomizeColumnMenu, ActivityLog } from '../../../../../components';

export default {
  name: 'TaskListToolbar',

  components: {
    CustomizeColumnMenu,
    ActivityLog,
  },

  props: {
    headers: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    hasActiveTableFilter: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      customizeMenuOpen: false,
      activityLogOpen: false,
    };
  },

  computed: {
    activityLogResourceId() {
      return String(this.$store.state.client || '');
    },
    activityLogTypes() {
      return ACTIVITY_LOG_TYPES.MASTER_TASKLIST;
    },
    checklistType() {
      return this.$constants.TASK_LIST_CONSTANTS.TASK_TYPES.NORMAL;
    },
    arType() {
      return this.$constants.TASK_LIST_CONSTANTS.TASK_TYPES.ACCOUNT_RECONCILIATION;
    },
  },

  methods: {
    async openActivityLog() {
      this.activityLogOpen = true;
      await this.$nextTick();
      this.$refs.activityLog?.openDialog();
    },
  },
};
</script>
